"use strict";

module.exports = {
  GLIMR_HOST: "//pixel.glimr.io",
  GLIMR_PATHS: {
    tags: "/v4/iptags/:id/",
    store: "/v4/collect/:id/"
  },

  MAX_CACHE_TIME: 300,

  CACHE_TIMINGS: {
    tags: 0
  },

  V2_PREFIX: "[v2]:"
};
